package one.devsbox.www.ui.widgets

import one.devsbox.shared.devices.ApplicationType
import org.jetbrains.compose.resources.StringResource
import one.devsbox.www.www_portal.generated.resources.*

val ApplicationType.label: StringResource
    get() = when (this) {
        ApplicationType.ANDROID_RUNTIME -> Res.string.application_type_android_runtime
        ApplicationType.LINUX_RUNTIME_X64 -> Res.string.application_type_linux_runtime_x64
        ApplicationType.LINUX_RUNTIME_ARM -> Res.string.application_type_linux_runtime_arm
        ApplicationType.WWW_CAMPAIGN -> Res.string.application_type_www_campaign
        ApplicationType.WWW_WHEEL -> Res.string.application_type_www_wheel
        ApplicationType.LINUX_INIT_X64 -> Res.string.application_type_linux_init_x64
    }
